module.exports = __webpack_public_path__ + "img/img_file_thumb.0c12c5ad.png";